import { observer } from 'mobx-react-lite'
import cn from 'classnames'

import { EventIcon, StepTooltip } from 'components'
import { analyticsContext, useValueContext } from 'contexts'
import { EventType, IEvent } from 'types'
import './styles.scss'

const eventTypes = [
  {
    title: 'Левая',
    icon: 'BreastLeftIcon',
    type: EventType.BREAST_LEFT,
  },
  {
    title: 'Правая',
    icon: 'BreastRightIcon',
    type: EventType.BREAST_RIGHT,
  },
  {
    title: 'Бутылочка',
    icon: 'FeedBottleIcon',
    type: EventType.BOTTLE,
  },
  {
    title: 'Сон',
    icon: 'SleepIcon',
    type: EventType.SLEEP_DAY,
  },
  {
    title: 'Ка-ка',
    icon: 'PoopIcon',
    type: EventType.POO,
  },
  {
    title: 'Пи-пи',
    icon: 'PeeIcon',
    type: EventType.PEE,
  },
]

const setType = (type: EventType): EventType => {
  const hours = new Date().getHours()
  if (type === EventType.SLEEP_NIGHT && hours >= 6 && hours < 20) {
    return EventType.SLEEP_DAY
  }
  if (type === EventType.SLEEP_DAY && (hours < 6 || hours >= 20)) {
    return EventType.SLEEP_NIGHT
  } else return type
}

export const EventTypes = observer(() => {
  const { store, baby } = useValueContext()
  const { currentEvents, createEvent, toggleEvent, addEventOnFrontend } = store
  const currentEventsTypes = currentEvents.map(({ eventTypeCode }: IEvent) => eventTypeCode)

  const handleEventClick = async (eventType: EventType) => {
    if (!baby) {
      return
    }

    analyticsContext.trackEvent('quick_button_clicked', { event_name: eventType })

    const e: IEvent = {
      startTime: new Date().toISOString(),
    }

    if ([EventType.POO, EventType.PEE].includes(eventType)) {
      const event = await createEvent(e, eventType)
      addEventOnFrontend(event)
    } else {
      e.id = new Date().getTime()
      e.endTime = null
      toggleEvent(e, setType(eventType))
    }
  }

  return (
    <div className="event-types-container">
      <div className="event-types-wrapper with-scroll">
        <StepTooltip
          step={1}
          left={4}
          top={90}
          width={220}
          position="bottom-right"
          content="Отмечайте события сна и кормления нажатием на эти кнопки"
        />
        <div className="event-types">
          {eventTypes.map(({ title, icon, type }) => {
            let isActive = currentEventsTypes.includes(type)

            if (type === EventType.SLEEP_DAY) {
              isActive = isActive || currentEventsTypes.includes(EventType.SLEEP_NIGHT)
            }

            return (
              <div className="event-type" key={title}>
                <EventIcon
                  iconName={icon}
                  iconProps={{ width: 45, height: 45 }}
                  width={80}
                  height={80}
                  className={cn({ active: isActive })}
                  onClick={() => handleEventClick(type)}
                />
                <div className="title">{title}</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
})
